module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic__mobile--FR-6fb5a6005f04dffad1e0768a0f9555b9.jpg";